/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    selected: PropTypes.bool,
    onSelectionChange: PropTypes.func,
};

const defaultProps = {
    selected: false,
    onSelectionChange: () => {},
};

export default class ExtendedStay extends React.Component {
    constructor() {
        super();
        this.onSelection = this.onSelection.bind(this);
    }

    onSelection(selected) {
        this.props.onSelectionChange(selected);
    }

    render() {
        return (
            <div className="rec-nested-wrap">
                <div className="rec-grid-12-12">
                    <h6 className="bottom-1">Extended Stay</h6>
                    <div className="rec-form-check-wrap">
                        <label
                            htmlFor="extended-stay-checkbox"
                            className="rec-label-checkbox"
                        >
                            <input
                                id="extended-stay-checkbox"
                                className="rec-input-hide"
                                type="checkbox"
                                checked={this.props.selected}
                                onChange={(e) => this.onSelection(e.target.checked)}
                            />
                            <span className="rec-input-checkbox" />
                            <span>
                                Request to stay an extra day for an additional $35. This
                                facility reserves the right to reject this request before
                                your launch depending upon availability, if this happens
                                you will be refunded your payment.
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

ExtendedStay.propTypes = propTypes;
ExtendedStay.defaultProps = defaultProps;
